// Mirrors dbo.order_payment_status seed data (1 Requested ... 8 Canceled). Hardcoded
// deliberately - stable 8-row lookup table, no GET endpoint exists for it (nor is one
// planned; see the 5.4 Customer Payments plan/project memory for the reasoning).
export const PAYMENT_STATUSES = [
  { OrderPaymentStatusID: 1, StatusName: 'Requested' },
  { OrderPaymentStatusID: 2, StatusName: 'Authorized' },
  { OrderPaymentStatusID: 3, StatusName: 'Submitted' },
  { OrderPaymentStatusID: 4, StatusName: 'Processing' },
  { OrderPaymentStatusID: 5, StatusName: 'Settled' },
  { OrderPaymentStatusID: 6, StatusName: 'Confirmed' },
  { OrderPaymentStatusID: 7, StatusName: 'Failed' },
  { OrderPaymentStatusID: 8, StatusName: 'Canceled' },
];
